import React from 'react'

const Divider = ({height="10px", bottom, borderSize = "1px", color = "#c0bfbf"}) => {
  return (<div style={{borderBottom:`${borderSize} solid ${color}`, height, marginBottom: bottom}}/>)
}

export default Divider
